// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__-xZrl","header":"ReportDetails_header__a40wK","title":"ReportDetails_title__2sHQ3","left":"ReportDetails_left__olKGO"};